var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['modalCard', _vm.isVisible && 'modalCard--show']},[(_vm.isVisible)?_c('div',{staticClass:"modalCard__overlay",on:{"click":_vm.closeModal}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }